<header class="fixed-top bg-white">
	<div class="pb-2 pb-lg-3 redGradient"></div>
	<nav class="container-xxl bg-white">
		<h1 class="text-center text-lg-start my-1">
			<a routerLink="/">
				<img
					class="w-auto"
					[src]="wcmService.logoUrl"
					alt="Homepage"
					title="Homepage"
				/>
			</a>
		</h1>
	</nav>
</header>